import { Link } from 'react-router-dom';
import { Instagram, Twitter, Facebook, Linkedin, Mail } from 'lucide-react';
import { Container } from './layout/Container';

// Footer navigation structure - from frontend (real routes)
const footer_links = {
  marketplace: [
    { label: 'Explorar Arte', href: '/explorar' },
    { label: 'Artistas', href: '/artistas' },
    { label: 'Categorías', href: '/explorar' },
  ],
  legal: [
    { label: 'Términos y Condiciones', href: '/terminos' },
    { label: 'Política de Privacidad', href: '/privacidad' },
    { label: 'Propiedad Intelectual', href: '/propiedad-intelectual' },
    { label: 'Devoluciones y Disputas', href: '/devoluciones' },
    { label: 'Código de Conducta', href: '/codigo-de-conducta' },
  ],
  company: [
    { label: 'Sobre RAIOS', href: '/sobre-raios' },
    { label: 'Noticias', href: '/noticias' },
    { label: 'Contacto', href: 'mailto:raios.comunidad@gmail.com', external: true },
  ],
};

const social_links = [
  { icon: Facebook, href: '#', label: 'Facebook' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Mail, href: 'mailto:raios.comunidad@gmail.com', label: 'Email' },
];

/**
 * Footer - Pie de página minimal RAIOS
 *
 * DISEÑO: del maqueteo (Container, glassmorphism, estructura visual)
 * CONTENIDO: del frontend (footer_links con rutas reales, social_links)
 */
const Footer = () => {
  const current_year = new Date().getFullYear();

  return (
    <footer className="w-full mt-auto bg-[rgba(10,2,24,0.75)] backdrop-blur-sm border-t border-raios-text-support/10 mt-8">
      <Container>
        {/* Main Footer */}
        <div className="py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-mono text-xl font-bold text-raios-text-high">
                RAIOS
              </span>
              <span className="font-mono text-xs text-raios-primary tracking-widest ml-1">
                ARTE
              </span>
            </Link>
            <p className="font-sans text-sm text-raios-text-support mb-6 max-w-xs">
              Mercado de arte con propósito. Elevando el talento local desde su origen.
            </p>

            {/* Social Links */}
            <div className="flex flex-wrap gap-1">
              {social_links.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    className="p-2 text-raios-text-support hover:text-raios-primary transition-colors"
                    aria-label={social.label}
                  >
                    <IconComponent size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Marketplace Links */}
          <div>
            <h4 className="font-mono text-sm font-bold text-raios-text-high mb-4 uppercase tracking-wider">
              Marketplace
            </h4>
            <ul className="space-y-3">
              {footer_links.marketplace.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="font-sans text-sm text-raios-text-support hover:text-raios-text-high transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-mono text-sm font-bold text-raios-text-high mb-4 uppercase tracking-wider">
              Legal
            </h4>
            <ul className="space-y-3">
              {footer_links.legal.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="font-sans text-sm text-raios-text-support hover:text-raios-text-high transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-mono text-sm font-bold text-raios-text-high mb-4 uppercase tracking-wider">
              Empresa
            </h4>
            <ul className="space-y-3">
              {footer_links.company.map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <a
                      href={link.href}
                      className="font-sans text-sm text-raios-text-support hover:text-raios-text-high transition-colors"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="font-sans text-sm text-raios-text-support hover:text-raios-text-high transition-colors"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-raios-text-support/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-sans text-sm text-raios-text-support">
            © {current_year} RAIOS Arte. Todos los derechos reservados.
          </p>

          <p className="font-mono text-xs text-raios-text-support/60">
            Hecho con intención, para que lo valioso sea visto.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
